module.exports = __webpack_public_path__ + "static/img/label-03.3ec3e74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/kerry/label-03.png
// module id = Ayi7
// module chunks = 31